import styled from "styled-components";

import { FlexColumn } from "@similarweb/ui-components";

export const ProgressBarWrapper = styled(FlexColumn)`
    height: 8px;
    .sw-progress-bar {
        border-radius: 2px;
        width: 122px;
    }
`;
